import * as React from 'react';
import { SVGProps } from 'react';

const IconAmplitudeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 13h10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"
      fill="url(#SvgIconAmplitude_size_s__a)"
    />
    <path fill="url(#SvgIconAmplitude_size_s__b)" d="M1 12h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__c)" d="M1 11h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__d)" d="M1 10h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__e)" d="M1 9h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__f)" d="M1 8h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__g)" d="M1 7h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__h)" d="M1 4h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__i)" d="M1 5h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__j)" d="M1 6h10v1H1z" />
    <path fill="url(#SvgIconAmplitude_size_s__k)" d="M1 3h10v1H1z" />
    <path
      d="M1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1H1Z"
      fill="url(#SvgIconAmplitude_size_s__l)"
    />
    <path
      d="M14 4h1l-1.5-2L12 4h1v8h-1l1.5 2 1.5-2h-1V4Z"
      fill="var(--color-typo-primary)"
    />
    <defs>
      <linearGradient
        id="SvgIconAmplitude_size_s__a"
        x1={11}
        y1={13.5}
        x2={1}
        y2={13.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0266" />
        <stop offset={1} stopColor="#950BFF" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__b"
        x1={11}
        y1={12.5}
        x2={1}
        y2={12.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C0B66" />
        <stop offset={1} stopColor="#BE37FF" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__c"
        x1={11}
        y1={11.5}
        x2={1}
        y2={11.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A3364" />
        <stop offset={1} stopColor="#F1D3FF" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__d"
        x1={11}
        y1={10.5}
        x2={1}
        y2={10.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20205D" />
        <stop offset={1} stopColor="#9797FD" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__e"
        x1={11}
        y1={9.5}
        x2={1}
        y2={9.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#621C66" />
        <stop offset={1} stopColor="#FF86FF" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__f"
        x1={11}
        y1={8.5}
        x2={1}
        y2={8.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#644A33" />
        <stop offset={1} stopColor="#FFF1D3" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__g"
        x1={11}
        y1={7.5}
        x2={1}
        y2={7.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#663A1C" />
        <stop offset={1} stopColor="#FFDD86" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__h"
        x1={11}
        y1={4.5}
        x2={1}
        y2={4.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#661F02" />
        <stop offset={1} stopColor="#FF950B" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__i"
        x1={11}
        y1={5.5}
        x2={1}
        y2={5.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#662C0B" />
        <stop offset={1} stopColor="#FFBE37" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__j"
        x1={11}
        y1={6.5}
        x2={1}
        y2={6.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6C2402" />
        <stop offset={1} stopColor="#EA9312" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__k"
        x1={11}
        y1={3.5}
        x2={1}
        y2={3.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5B000A" />
        <stop offset={1} stopColor="#FD002D" />
      </linearGradient>
      <linearGradient
        id="SvgIconAmplitude_size_s__l"
        x1={11}
        y1={2.5}
        x2={1}
        y2={2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#210009" />
        <stop offset={1} stopColor="#9C002B" />
      </linearGradient>
    </defs>
  </svg>
);
export default IconAmplitudeSizeS;
